import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import PlainIDMCPAuthorizerDemo from './PlainIDMCPAuthorizerDemo';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PlainIDMCPAuthorizerDemo />
  </React.StrictMode>
);
